import { render, staticRenderFns } from "./ChargerEditorPopup.vue?vue&type=template&id=22d920b0"
import script from "./ChargerEditorPopup.vue?vue&type=script&lang=js"
export * from "./ChargerEditorPopup.vue?vue&type=script&lang=js"
import style0 from "./ChargerEditorPopup.vue?vue&type=style&index=0&id=22d920b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports